import { render } from "./NewStockTake.vue?vue&type=template&id=0ba842d7"
import script from "./NewStockTake.vue?vue&type=script&lang=js"
export * from "./NewStockTake.vue?vue&type=script&lang=js"

import "./NewStockTake.vue?vue&type=style&index=0&id=0ba842d7&lang=css"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__